import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { get } from "lodash";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { renderIf, toggleSwitch } from "MODULES/shared/decorators";
import { Icon } from "MODULES/shared/components";
import { CONSIGNMENT_TYPE, INVENTORY } from "MODULES/inventories/constants";
import pojo from "LIB/pojos";
import { CANCELLATION_REASONS } from "MODULES/SalesOrders/constants";
import { cancel } from "../../../../actions";
import Reason from "./Reason";

export function Cancel({ cancelSo, cancelling, open, close, salesOrder }) {
  const initialValues = {
    cancellation_reason: CANCELLATION_REASONS[0].value,
    line_items: salesOrder.line_items.map(l => pojo(l).pick("id", "inventory"))
  };

  return (
    <DropDownItem onClick={open}>
      <Reason
        initialValues={initialValues}
        visible={cancelling}
        close={close}
        cancel={cancelSo}
        salesOrder={salesOrder}
      />
      <span className="text-danger">
        <Icon name="ban" fixed />
        &nbsp;Cancel SO
      </span>
    </DropDownItem>
  );
}

Cancel.propTypes = {
  open: T.func.isRequired,
  close: T.func.isRequired,
  cancelling: T.bool.isRequired
};

const ifNoneCancelledOrShipped = renderIf(({ salesOrder }) =>
  salesOrder.line_items.every(
    l =>
      !l.cancelled &&
      !l.shipped &&
      !get(l, [INVENTORY, CONSIGNMENT_TYPE].join("."))
  )
);

export default ifNoneCancelledOrShipped(
  toggleSwitch("cancelling")(
    connect(undefined, (dispatch, ownProps) => ({
      cancelSo: (reason, sendEmail) =>
        dispatch(
          cancel(ownProps.salesOrder.id, reason, sendEmail, ownProps.close)
        )
    }))(Cancel)
  )
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/Cancel/Cancel.jsx